<template>
    <div class="container-fluid">
        <div class="row" v-if="loading">
            <div class="col-12 text-center g">
                <br><br><br>
                <div class="spinner-border text-primary" style="width: 6rem; height: 6rem;" role="status">
                    <span class="sr-only">Loading...</span>
                </div><br>
                <br>جاري الاستعلام...
            </div>
        </div>
        <div class="row" v-if="!loading">
            <div class="col-12 col-lg-4">
               <div class="card card-body">
                 <div id="chart">
                        <apexchart
                            type="pie"
                            :options="chartOptions"
                            :series="PieSeries"
                        ></apexchart>
                    </div>
               </div>
               <div class="card card-body">
                 <div id="chart">
                        <apexchart
                            type="pie"
                            :options="chartOptions2"
                            :series="PieSeries2"
                        ></apexchart>
                    </div>
               </div>
            </div>
            <div class="col-12 col-lg-8">
               <div class="card card-body">
                 <div id="chart">
                        <apexchart
                            type="area"
                            :options="chart2Options"
                            :series="series"
                        ></apexchart>
                    </div>
               </div>
            </div>
            <div class="col-12">
               <div class="card card-body">
                 <div id="chart">
                        <apexchart
                            type="area"
                            :options="chart3Options"
                            :series="series3"
                        ></apexchart>
                    </div>
               </div>
            </div>
        </div>
    </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts';
import Ripple from "vue-ripple-directive";
import { VBModal, BModal } from "bootstrap-vue";
export default {
    directives: {
        Ripple,
        "b-modal": VBModal,
    },
     components: {
        BModal,
        apexchart: VueApexCharts
    },
    data(){
        return {
            user: JSON.parse(localStorage.getItem('user')),
            stats: {},
            loading: true,
            // pie
            PieSeries: [],
            chartOptions: {
                chart: {
                type: 'pie',
                },

                fill: {
                type: 'gradient',
                },
                labels: [],
                responsive: [{
                breakpoint: 480,
                options: {
                    chart: {
                    },
                    legend: {
                    position: 'bottom'
                    }
                }
                }]
            },
            // pie
            PieSeries2: [],
            chartOptions2: {
                chart: {
                type: 'pie',
                },

                fill: {
                type: 'gradient',
                },
                tooltip: {
                    y: {
                        formatter: function (value) {
                            return 'ريال ' + value.toFixed(0);
                        }
                    }
                },
                dataLabels: {
                    formatter: function (val, { seriesIndex, w }) {
                        return 'ريال ' + w.config.series[seriesIndex].toFixed(0);
                    }
                },
                labels: [],
                responsive: [{
                breakpoint: 480,
                options: {
                    chart: {
                    },
                    legend: {
                    position: 'bottom'
                    }
                }
                }]
            },
            // area
            series: [],
            chart2Options: {
                chart: {
                height: 350,
                type: 'area'
                },
                dataLabels: {
                enabled: false
                },
                stroke: {
                curve: 'smooth'
                },
                xaxis: {
                type: 'datetime',
                categories: []
                },
                tooltip: {
                x: {
                    format: 'dd/MM/yy'
                },
                },
            },
            // area
            series3: [],
            chart3Options: {
                chart: {
                height: 350,
                type: 'area'
                },
                dataLabels: {
                enabled: false
                },
                stroke: {
                curve: 'smooth'
                },
                xaxis: {
                type: 'datetime',
                categories: []
                },
                tooltip: {
                x: {
                    format: 'dd/MM/yy'
                },
                },
            },
        }
    },
    created(){
        var g = this;
        g.getStats()
    },
    methods: {
        getStats(){
            var g = this;
            $.post(api + '/user/web/stats', {
                jwt: g.user.jwt,
            }).then(function(r){
                //
                g.PieSeries = r.response.PieSeries
                g.chartOptions.labels = r.response.labels
                g.PieSeries2 = r.response.PieSeries2
                g.chartOptions2.labels = r.response.labels2
                g.chart2Options.xaxis.categories = r.response.days
                g.chart3Options.xaxis.categories = r.response.days
                g.series = r.response.datedata
                g.series3 = r.response.data2
                //
                g.loading = false
            }) 
        }
    }
}
</script>

<style>
#cc li{
    padding: 10px;
}
</style>